export const getProfileResourceNameField = (resourceType: string) => {
    const resourceNameField =
        resourceType === "app"
            ? "appPath"
            : resourceType === "folder"
                ? "path"
                : resourceType === "Group"
                    ? "cn"
                    : resourceType === "Publisher"
                        ? "friendlyName"
                        : "urlName";
    return resourceNameField;
};